import { render, staticRenderFns } from "./parts-group-preview.vue?vue&type=template&id=dec69af4&scoped=true&"
import script from "./parts-group-preview.vue?vue&type=script&lang=ts&"
export * from "./parts-group-preview.vue?vue&type=script&lang=ts&"
import style0 from "./parts-group-preview.vue?vue&type=style&index=0&id=dec69af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec69af4",
  null
  
)

export default component.exports